export function getColour(text: string | undefined) {
  if (text === "FOO") return "success";
  if (text === "DRI") return "primary";
  if (text === "BET") return "info";
  if (text === "SHO") return "warning";
  if (text === "ASI") return "danger";
  if (text === "ENT") return "info";
  if (text === "TRI") return "success";
  if (text === "GEN") return "warning";
  if (text === "LNCH") return "warning";
  if (text === "WELC") return "info";
  if (text === "HELP") return "primary";
  if (text === "STOP") return "info";
  if (text === "FALL") return "dark";
  if (text === "EXCP") return "info";
  if (text === "OPER") return "danger";
  if (text === "EVE") return "success";
  if (text === "MEE") return "primary";
  if (text === "CLN") return "warning";
  if (text === "FAC") return "info";
  if (text === "SRV") return "dark";
  if (text === "WIF") return "primary";
  if (text === "LREQ") return "dark";
  if (text === "CLRQ") return "danger";
  if (text === "ARHS") return "success";
  if (text === "ORI") return "info";
  if (text === "AVAL") return "success";
  if (text === "MEN") return "danger";
  if (text === "NWS") return "warning";
  if (text === "NWA") return "dark";
  if (text === "BRC") return "black";
  if (text === "SVY") return "black";
  if (text === "WBL") return "info";
  if (text === "CHM") return "success";
  if (text === "I") return "warning";
  if (text === "O") return "danger";
  if (text === "OP") return "danger";
  if (text === "CM") return "warning";
  if (text === "AD") return "primary";
  if (text === "CO") return "success";
  if (text === "DV") return "info";
  if (text === "AN") return "success";
  if (text === "EV") return "primary";
  if (text === "WH") return "danger";
  if (text === "MN") return "danger";
  if (text === "PI") return "info";
  if (text === "DR") return "warning";
  if (text === "RO") return "success";
  if (text === "SV") return "success";
  if (text === "RP") return "primary";
  if (text === "RT") return "info";
  if (text === "TR") return "warning";
  if (text === "PA") return "primary";
  if (text === "PH") return "primary";
  if (text === "NL") return "info";
  if (text === "PMI") return "primary";
  if (text === "SMC") return "warning";
  if (text === "SVY") return "success";
  if (text === "WBL") return "danger";
  if (text === "NOW") return "danger";
  if (text === "FUT") return "primary";
  if (text === "INT") return "success";
  if (text === "MIN") return "success";
  if (text === "HRS") return "warning";
  if (text === "DAY") return "primary";
  if (text === "PRD") return "success";
  if (text === "ALL") return "success";
  if (text === "DOW") return "warning";
  if (text === "DOM") return "primary";
  if (text === "A") return "danger";
  if (text === "N") return "warning";
  if (text === "P") return "warning";
  if (text === "F") return "danger";
  if (text === "C") return "success";
  if (text === "E") return "success";
  if (text === "D") return "warning";
  if (text === "YES") return "success";
  if (text === "NO") return "danger";
  if (text === "MS") return "warning";
  if (text === "FS") return "danger";
  if (text === "MR") return "warning";
  if (text === "MA") return "success";
  if (text === "FOOR") return "success";
  if (text === "DRIR") return "primary";
  if (text === "ENTR") return "info";
  if (text === "ASIR") return "danger";
  if (text === "OPERR") return "danger";
  if (text === "CLNR") return "warning";
  if (text === "FACR") return "info";
  if (text === "CANM") return "success";
  if (text === "DANM") return "danger";
  if (text === "CEVE") return "success";
  if (text === "DEVE") return "danger";
  if (text === "MNT") return "info";
  if (text === "HAS") return "danger";
  if (text === "CMP") return "primary";
  if (text === "OTH") return "secondary";
  return "secondary";
}

export function getColours(text: string | undefined) {
  if (text === "donut-chart")
    return ["#bd74b7", "#67C4E6", "#4adf9f", "#ffc657", "#ff7181"];
  if (text === "radial-chart") return ["rgb(125 211 252)", "rgb(209 213 219)"];
  if (text === "multi-time-series-chart")
    return [
      getColourPaletteHex("light-primary"),
      getColourPaletteHex("light-success"),
      getColourPaletteHex("light-warning"),
      getColourPaletteHex("light-danger"),
      getColourPaletteHex("light-info"),
      getColourPaletteHex("dark"),
      getColourPaletteHex("secondary"),
      getColourPaletteHex("primary"),
      getColourPaletteHex("success"),
      getColourPaletteHex("warning"),
      getColourPaletteHex("danger"),
      getColourPaletteHex("info"),
    ];
  return [
    "rgb(96 165 250)",
    "rgb(147 197 253)",
    "rgb(191 219 254)",
    "rgb(153 246 228)",
    "rgb(94 234 212)",
    "rgb(110 231 183)",
    "rgb(52 211 153)",
    "rgb(16 185 129)",
  ];
}

export function getColourPaletteHex(colour: string) {
  if (colour === "primary") return "#00a4e0";
  if (colour === "light-primary") return "#67C4E6";
  if (colour === "success") return "#20c980";
  if (colour === "light-success") return "#4adf9f";
  if (colour === "warning") return "#ffa800";
  if (colour === "light-warning") return "#ffc657";
  if (colour === "danger") return "#f64e60";
  if (colour === "light-danger") return "#ff7181";
  if (colour === "info") return "#9a4c94";
  if (colour === "light-info") return "#bd74b7";
  if (colour === "dark") return "#003560";
  if (colour === "black") return "#000000";
  if (colour === "secondary") return "797977";
  return "#a6a6a4";
}
